/* ══════════════════════════════════════════════════════════════════════════
   ILUMEISTER — CLIENT-SIDE TRANSLATION ENGINE
   ET (default) ↔ EN / FI
   Works on all pages without design changes.
   Called by: window.setLang('en') | window.setLang('fi') | window.setLang('et')
══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── TRANSLATION MAPS ─────────────────────────────────────────────────── */
  var M = {

    en: {
      /* NAV / GLOBAL */
      "Avaleht": "Home",
      "Teenused": "Services",
      "Tooted": "Products",
      "Broneeri": "Book",
      "Broneeri Aeg": "Book Now",
      "Broneeri Aeg →": "Book Now →",
      "Blogi": "Blog",
      "Meist": "About",
      "Kontakt": "Contact",
      "Hele": "Light",
      "Tume": "Dark",

      /* FLOATING CTA */
      "Broneeri Aeg →": "Book Now →",

      /* REVIEWS WIDGET */
      "Google arvustused": "Google reviews",
      "Broneeri aeg →": "Book a time →",
      "Vaata kõiki arvustusi": "See all reviews",

      /* BREADCRUMBS */
      "Broneeri Aeg": "Book Now",

      /* FOOTER */
      "Navigatsioon": "Navigation",
      "Lahtiolekuajad": "Opening Hours",
      "Kokkuleppel": "By appointment",
      "Kõik õigused kaitstud.": "All rights reserved.",
      "Kõik õigused kaitstud": "All rights reserved",
      "Privaatsuspoliitika": "Privacy Policy",
      "Kasutustingimused": "Terms of Service",
      "Tagastuspoliitika": "Refund Policy",
      "Disainitud armastusega Tallinna Vanalinnas": "Designed with love in Tallinn's Old Town",
      "Professionaalsed ripsmepikendused Tallinna Vanalinnas. Rüütli 28.": "Professional lash extensions in Tallinn Old Town. Rüütli 28.",
      "Professionaalsed ripsmepikendused ja kaunitushooldused Tallinna Vanalinnas. Üle 15 aasta kogemust.": "Professional lash extensions and beauty treatments in Tallinn's Old Town. Over 15 years of experience.",

      /* HOMEPAGE — HERO */
      "Tallinna parim ripsmekunstnik": "Tallinn's best lash artist",
      "Kunst, mis avab": "Art that opens",
      "Sinu loomulik": "your natural",
      "ilu": "beauty",
      "Vaata Teenuseid": "View Services",
      "Meie Enimmüüdud Tooted": "Our Best-Selling Products",
      "Kerige": "Scroll",

      /* HOMEPAGE — MARQUEE */
      "5★ Google Hinnang": "5★ Google Rating",
      "Üle 15 Aasta Kogemust": "Over 15 Years of Experience",
      "2023 Finalisti Auhind": "2023 Finalist Award",
      "Tallinna Vanalinn": "Tallinn Old Town",
      "Individuaalne Lähenemine": "Individual Approach",
      "Premium Materjalid": "Premium Materials",
      "100% Rahulolu": "100% Satisfaction",

      /* HOMEPAGE — TRUST BAR */
      "Aastat Kogemust": "Years of Experience",
      "Rahuldatud Klienti": "Satisfied Clients",
      "Google Tärnid": "Google Stars",
      "Teenust": "Services",

      /* HOMEPAGE — SERVICES */
      "Meie Teenused": "Our Services",
      "Iga silmapilk,": "Every moment,",
      "täiuslikult raamitud": "perfectly framed",
      "Kõik teenused kasutavad LED liimu — kahjutum, vastupidavam.": "All services use LED glue — safer, more durable.",
      "Vaata kõiki teenuseid": "View all services",
      "Klassikalised Ripsmepikendused": "Classic Lash Extensions",
      "Mahuripsmepikendused": "Volume Lash Extensions",
      "Ripsmete Lift": "Lash Lift",
      "Kulmuhooldus & Lift": "Brow Treatment & Lift",
      "Mega Maht / Rus Maht": "Mega Volume / Russian Volume",
      "Ripsmepikenduste Täitmine": "Lash Extension Fill",
      "Klassikalised LED": "Classic LED",
      "Ripsmepikendused": "Lash Extensions",
      "Hübriid LED": "Hybrid LED",
      "Volüümi LED": "Volume LED",
      "Pruunid LED": "Brown LED",
      "koos toonimisega": "with tinting",
      "Asian Lash Lift koos toonimisega": "Asian Lash Lift with Tinting",
      "alates": "from",
      "Broneeri →": "Book →",

      /* HOMEPAGE — REVIEWS */
      "Google Arvustused": "Google Reviews",
      "Mida kliendid": "What clients",
      "räägivad": "are saying",
      "Ühendamine Google'iga...": "Connecting to Google...",
      "Uuenda": "Refresh",

      /* HOMEPAGE — BOOKING WIDGET */
      "Online Broneerimine": "Online Booking",
      "Broneeri oma": "Book your",
      "aeg kohe": "appointment now",
      "1 / 3 — Vali Teenus": "1 / 3 — Choose Service",
      "2 / 3 — Vali Kuupäev": "2 / 3 — Choose Date",
      "3 / 3 — Vali Kellaaeg": "3 / 3 — Choose Time",
      "Vali teenus...": "Select service...",
      "Vali Kuupäev →": "Choose Date →",
      "Kinnita Broneering →": "Confirm Booking →",
      "← Tagasi": "← Back",
      "Broneering Kinnitatud!": "Booking Confirmed!",
      "Uus Broneering": "New Booking",
      "Kinnitus saadetakse e-mailile.": "Confirmation sent to your email.",
      "Broneeri kohe": "Book Now",
      "Vali teenus & ava kalender": "Choose service & open calendar",

      /* HOMEPAGE — BLOG SLIDE */
      "◆  Ilumeistri Blogi": "◆  Ilumeister's Blog",
      "Ekspertteadmised": "Expert Tips",
      "& Uudised": "& News",
      "Laura ekspertnõuanded, tootearvustused ja kaunitsuudised.": "Laura's expert tips, product reviews and beauty news.",
      "Vaata kõiki artikleid": "View all articles",

      /* HOMEPAGE — GALLERY */
      "Töid, mis": "Work that",
      "räägivad ise": "speaks for itself",

      /* HOMEPAGE — BEFORE/AFTER */
      "Enne & Pärast": "Before & After",
      "Näe vahet": "See the difference",
      "ise": "yourself",
      "Enne": "Before",
      "Pärast": "After",

      /* HOMEPAGE — ABOUT */
      "Ripsmekunstnik": "Lash Artist",

      /* HOMEPAGE — MAP */
      "Meie Asukoht": "Our Location",
      "Tallinna Vanalinnas,": "In Tallinn's Old Town,",
      "stuudio südames": "at the heart of the studio",
      "Ilumeister Studio": "Ilumeister Studio",
      "Aadress": "Address",
      "Tööaeg": "Opening Hours",
      "Telefon": "Phone",
      "Ava Google Maps": "Open Google Maps",

      /* TEENUSED PAGE */
      "Ripsmepikendused & Kaunitushooldused": "Lash Extensions & Beauty Treatments",
      "Üheksa eksklusiivset teenust — hoolikalt valitud, professionaalselt sooritatud. Iga teenus on kohandatud Sinu unikaalsele ilule.": "Nine exclusive services — carefully selected, professionally delivered. Each service is tailored to your unique beauty.",

      /* TEENUSED — SERVICE LABELS */
      "LED Ripsmepikendused": "LED Lash Extensions",
      "Korrektuur": "Correction",
      "Ripsmete Korrektuur": "Lash Correction",
      "Kulmud": "Brows",
      "Kulmude Disain": "Brow Design",
      "Hammas Kivi": "Tooth Gem",
      "Hammas Kivi · Uus 2026": "Tooth Gem · New 2026",
      "Küüned · Uus 2026": "Nails · New 2026",
      "Küünekujundus": "Nail Art",
      "Hind kokkuleppel": "Price upon request",

      /* TEENUSED — PRICING TABLE */
      "Hinnakirja Ülevaade": "Pricing Overview",
      "Kõik": "All",
      "hinnad": "prices",
      "Teenus": "Service",
      "Kestus": "Duration",
      "Hooldus": "Maintenance",
      "Hind": "Price",
      "Klassikalised LED Ripsmepikendused": "Classic LED Lash Extensions",
      "Hübriid LED Ripsmepikendused": "Hybrid LED Lash Extensions",
      "Volüümi LED Ripsmepikendused": "Volume LED Lash Extensions",
      "Pruunid LED Ripsmepikendused": "Brown LED Lash Extensions",
      "Vastavalt vajadusele": "As needed",
      "Kokkuleppel": "On request",
      "Makseviisid:": "Payment methods:",
      "Tühistamine:": "Cancellation:",
      "Kõik hinnad sisaldavad käibemaksu.": "All prices include VAT.",

      /* TEENUSED — CTA BANNER */
      "Valmis alustama?": "Ready to begin?",
      "täna": "today",
      "Laura on valmis looma Teile täiusliku ilutulemi. Broneerige mugavalt veebis — valige teenus, kuupäev ja kellaaeg.": "Laura is ready to create your perfect beauty outcome. Book conveniently online — choose your service, date and time.",
      "Küsi Nõu": "Ask for Advice",

      /* BRONEERI PAGE */
      "Võtke Meiega Ühendust": "Get in Touch",
      "Online Broneerimine": "Online Booking",
      "oma aeg": "your appointment",
      "Vali sobiv": "Choose your",
      "aeg": "appointment",
      "Broneeri mugavalt veebis — vali teenus, kuupäev ja kellaaeg. Kinnitus saadetakse Teie e-mailile kohe pärast broneerimist.": "Book conveniently online — choose a service, date and time. Confirmation is sent to your email immediately after booking.",
      "Teisipäev – Laupäev": "Tuesday – Saturday",
      "Teisipäev – Laupäev: 12:00–21:00": "Tuesday – Saturday: 12:00–21:00",
      "Pühapäev – Esmaspäev: Suletud": "Sunday – Monday: Closed",
      "Laupäev": "Saturday",
      "Pühapäev – Esmaspäev": "Sunday – Monday",
      "Suletud": "Closed",
      "Oluline Teada": "Important Info",
      "Broneerimise": "Booking",
      "tingimused": "conditions",
      "Tühistamise Poliitika": "Cancellation Policy",
      "Palun tühistage broneering vähemalt 24 tundi ette. Hilisem tühistamine toob kaasa 100% teenustasu. Haigestumise korral võtke ühendust esimesel võimalusel.": "Please cancel at least 24 hours in advance. Late cancellations incur 100% of the service fee. In case of illness, contact us as soon as possible.",
      "Makseviisid": "Payment Methods",
      "Aktsepteerime kontaktivabat kaarti, sularaha ja pangaülekannet. Makse toimub peale protseduuri sooritamist salongis.": "We accept contactless card, cash and bank transfer. Payment is made after the procedure in the salon.",
      "Protseduuriks Valmistumine": "Preparation",
      "Palun tulge puhaste silmadega — ilma ripsmetušši ja silmaümbruskreemita. Kontaktläätsi kasutajatel soovitame läätsi mitte kanda protseduuril.": "Please come with clean eyes — without mascara and eye cream. Contact lens wearers are advised not to wear lenses during the procedure.",
      "Korduvad Küsimused": "Frequently Asked Questions",
      "KKK": "FAQ",

      /* BRONEERI — WIDGET SERVICES */
      "Klassikalised LED Ripsmepikendused — €60": "Classic LED Lash Extensions — €60",
      "Hübriid LED Ripsmepikendused — €65": "Hybrid LED Lash Extensions — €65",
      "Volüümi LED Ripsmepikendused — €70": "Volume LED Lash Extensions — €70",
      "Pruunid LED Ripsmepikendused — al. €60 (–15%)": "Brown LED Lash Extensions — from €60 (–15%)",
      "Asian Lash Lift koos toonimisega — €45": "Asian Lash Lift with Tinting — €45",
      "Ripsmete Korrektuur — €15–60": "Lash Correction — €15–60",
      "Kulmude Disain — €20–40": "Brow Design — €20–40",
      "Küünekujundus — Hind kokkuleppel": "Nail Art — Price on request",
      "Hammas Kivi — Hind kokkuleppel": "Tooth Gem — Price on request",

      /* BRONEERI — FAQ ANSWERS */
      "Kui kaua protseduur kestab?": "How long does the procedure take?",
      "Mida peaksin enne protseduuri teadma?": "What should I know before the procedure?",
      "Kui kaua ripsmepikendused kestavad?": "How long do lash extensions last?",
      "Kas tundlikud silmad sobivad?": "Are sensitive eyes suitable?",
      "Kuidas tühistada või aega muuta?": "How do I cancel or reschedule?",

      /* KONTAKT PAGE */
      "& Asukoht": "& Location",
      "Meie Kontaktandmed": "Our Contact Details",
      "Leia meid": "Find us",
      "Vanalinnas": "in Old Town",
      "Ilumeister salong asub Tallinna südames — rahulikul, eksklusiivselt Teile mõeldud ruumis Rüütli tänaval. Olete alati oodatud!": "Ilumeister salon is in the heart of Tallinn — a calm, exclusively designed space on Rüütli Street. You are always welcome!",
      "E-post": "Email",
      "Ava Google Maps →": "Open Google Maps →",
      "Teekonnakirjeldus": "Get Directions",
      "Teisipäev": "Tuesday",
      "Kolmapäev": "Wednesday",
      "Neljapäev": "Thursday",
      "Reede": "Friday",
      "Saada Sõnum": "Send a Message",
      "Küsimused, tagasiside või muud soovid — vastame esimesel võimalusel.": "Questions, feedback or other requests — we will respond at the earliest opportunity.",
      "Eesnimi": "First Name",
      "Perekonnanimi": "Last Name",
      "Teema": "Subject",
      "Sõnum": "Message",
      "Vali teema...": "Select topic...",
      "Broneerimine": "Booking",
      "Teenuse info": "Service info",
      "Hinnakiri": "Pricing",
      "Koolitused": "Training",
      "Muu küsimus": "Other question",
      "Saada Sõnum →": "Send Message →",
      "Sõnum saadetud!": "Message sent!",
      "Täname teiega ühenduse võtmise eest. Vastame Teile esimesel võimalusel, hiljemalt 1 tööpäeva jooksul.": "Thank you for getting in touch. We will respond as soon as possible, within 1 business day.",

      /* BLOG LISTING */
      "Ekspertteadmised & Uudised": "Expert Knowledge & News",
      "Ilumeistri": "Ilumeister's",
      "NAUTIMINE": "FEATURED",
      "Tootearvustus": "Product Review",
      "Uudised": "News",
      "Ekspertteadmised": "Expert Knowledge",
      "Hooldus & Nõuanded": "Care & Tips",
      "Loe edasi →": "Read more →",
      "Loe edasi": "Read more",
      "Püsi Kursis": "Stay Updated",
      "uudiskiri": "newsletter",
      "Saa esimesena teada uutest teenustest, erihinnapakkumistest ja Laura ekspertnõuannetest. Liitu meie eksklusiivsete lugejatega.": "Be the first to know about new services, special offers and Laura's expert tips. Join our exclusive readership.",
      "Teie e-posti aadress": "Your email address",
      "Liitu →": "Subscribe →",
      "Täname! ✦": "Thank you! ✦",

      /* ARTICLE PAGE */
      "Loe Veel": "Read More",
      "Seotud": "Related",
      "artiklid": "articles",
      "← Tagasi blogi": "← Blog",
      "Autor": "Author",

      /* PRODUCTS PAGE */
      "Lash & Brow Studio · Kollektsioon": "Lash & Brow Studio · Collection",
      "Puhtad ripsmed,": "Clean lashes,",
      "iga päev.": "every day.",
      "Esitoode": "Featured Product",
      "Keri alla": "Scroll down",
      "Lisa korvi": "Add to cart",
      "Osta kohe": "Buy Now",
      "Kollektsioon": "Collection",
      "Ilumeister Eksklusiiv": "Ilumeister Exclusive",
      "Ripsme": "Lash",
      "Šampoon": "Shampoo",
      "Täielik": "Complete",
      "rituaal,": "ritual,",
      "vaata lähemalt.": "take a closer look.",

      /* PRODUCTS GRID SECTION (homepage) */
      "◆  Meie Kauplus": "◆  Our Shop",
      "Meie Enimmüüdud": "Our Best-Selling",
      "Professionaalsed tooted, mida Laura ise kasutab ja soovitab.": "Professional products that Laura uses and recommends herself.",
      "Vaata kõiki tooteid": "View all products",

      /* SECTION EYEBROWS (common) */
      "Online Broneerimine": "Online Booking",

      /* HEADER — ACCOUNT / CART */
      "Logi sisse": "Log in",
      "Minu konto": "My account",
      "Ostukorv": "Cart",
      "Ostukorv on tühi": "Your cart is empty",
      "Vaata tooteid →": "View products →",
      "Kokku": "Total",
      "Jätka kassasse": "Proceed to checkout",
      "Vaata ostukorvi": "View cart",
      "Eemalda": "Remove",
      "Valitud teenus:": "Selected service:",
      "Otsas": "Out of stock",

      /* GALLERY / ABOUT / REVIEWS / HERO — EXTRAS */
      "Meie Tööd": "Our Work",
      "Valik tegelikest töödest": "A selection of real work",
      "Klientide Arvustused": "Client Reviews",
      "Vaata Google'is": "View on Google",
      "Värskenda": "Refresh",
      "Sinu kunstnik": "Your Artist",
      "Sinu Kunstnik": "Your Artist",
      "Ripsmemeister · 15+ aasta rahvusvaheline kogemus": "Lash Master · 15+ years international experience",
      "AASTAT KOGEMUST": "YEARS OF EXPERIENCE",
      "5.0/5 Google hinnang · 2000+ rahulolevat klienti": "5.0/5 Google rating · 2000+ happy clients",
      "Laadimine…": "Loading…",
      "Laadib arvustusi…": "Loading reviews…",
      "Live Google andmed": "Live Google data",
      "Vahemälust": "Cached",
      "Vahemälust (kuni 1h vana)": "Cached (up to 1h old)",      "(100% 5-tärni)": "(100% 5-star)"
    },

    fi: {
      /* NAV / GLOBAL */
      "Avaleht": "Etusivu",
      "Teenused": "Palvelut",
      "Tooted": "Tuotteet",
      "Broneeri": "Varaa",
      "Broneeri Aeg": "Varaa Aika",
      "Broneeri Aeg →": "Varaa Aika →",
      "Blogi": "Blogi",
      "Meist": "Meistä",
      "Kontakt": "Yhteystiedot",
      "Hele": "Vaalea",
      "Tume": "Tumma",

      /* FLOATING CTA */
      "Broneeri Aeg →": "Varaa Aika →",

      /* REVIEWS WIDGET */
      "Google arvustused": "Google-arvostelut",
      "Broneeri aeg →": "Varaa aika →",
      "Vaata kõiki arvustusi": "Katso kaikki arvostelut",

      /* FOOTER */
      "Navigatsioon": "Navigointi",
      "Lahtiolekuajad": "Aukioloajat",
      "Kokkuleppel": "Sopimuksen mukaan",
      "Kõik õigused kaitstud.": "Kaikki oikeudet pidätetään.",
      "Kõik õigused kaitstud": "Kaikki oikeudet pidätetty",
      "Privaatsuspoliitika": "Tietosuojaseloste",
      "Kasutustingimused": "Käyttöehdot",
      "Tagastuspoliitika": "Palautuskäytäntö",
      "Disainitud armastusega Tallinna Vanalinnas": "Suunniteltu rakkaudella Tallinnan vanhassa kaupungissa",
      "Professionaalsed ripsmepikendused Tallinna Vanalinnas. Rüütli 28.": "Ammattimaiset ripsienpidennykset Tallinnan vanhassa kaupungissa. Rüütli 28.",
      "Professionaalsed ripsmepikendused ja kaunitushooldused Tallinna Vanalinnas. Üle 15 aasta kogemust.": "Ammattimaisia ripsienpidennyksiä ja kauneushoitoja Tallinnan vanhassa kaupungissa. Yli 15 vuoden kokemus.",

      /* HOMEPAGE — HERO */
      "Tallinna parim ripsmekunstnik": "Tallinnan paras ripsiartisti",
      "Kunst, mis avab": "Taide, joka avaa",
      "Sinu loomulik": "sinun luonnollisen",
      "ilu": "kauneuden",
      "Vaata Teenuseid": "Katso palveluja",
      "Meie Enimmüüdud Tooted": "Myydyimmät tuotteemme",
      "Kerige": "Vieritä",

      /* HOMEPAGE — MARQUEE */
      "5★ Google Hinnang": "5★ Google-arvio",
      "Üle 15 Aasta Kogemust": "Yli 15 vuoden kokemus",
      "2023 Finalisti Auhind": "2023 Finalistipalkinto",
      "Tallinna Vanalinn": "Tallinnan vanha kaupunki",
      "Individuaalne Lähenemine": "Yksilöllinen lähestymistapa",
      "Premium Materjalid": "Premium materiaalit",
      "100% Rahulolu": "100% tyytyväisyys",

      /* HOMEPAGE — TRUST BAR */
      "Aastat Kogemust": "Vuotta kokemusta",
      "Rahuldatud Klienti": "Tyytyväistä asiakasta",
      "Google Tärnid": "Google-tähteä",
      "Teenust": "Palvelua",

      /* HOMEPAGE — SERVICES */
      "Meie Teenused": "Palvelumme",
      "Iga silmapilk,": "Jokainen hetki,",
      "täiuslikult raamitud": "täydellisesti kehystetty",
      "Kõik teenused kasutavad LED liimu — kahjutum, vastupidavam.": "Kaikki palvelut käyttävät LED-liimaa — turvallisempaa, kestävämpää.",
      "Vaata kõiki teenuseid": "Katso kaikki palvelut",
      "Klassikalised Ripsmepikendused": "Klassiset Ripsienpidennykset",
      "Mahuripsmepikendused": "Volyyymi Ripsienpidennykset",
      "Ripsmete Lift": "Ripsien Laminointi",
      "Kulmuhooldus & Lift": "Kulmahoito & Laminointi",
      "Mega Maht / Rus Maht": "Mega Volyymi / Venäläinen Volyymi",
      "Ripsmepikenduste Täitmine": "Ripsienpidennys Täyttö",
      "Klassikalised LED": "Klassiset LED",
      "Ripsmepikendused": "Ripsienpidennykset",
      "Hübriid LED": "Hybridi LED",
      "Volüümi LED": "Volyyymi LED",
      "Pruunid LED": "Ruskeat LED",
      "koos toonimisega": "värityksen kanssa",
      "Asian Lash Lift koos toonimisega": "Asian Lash Lift värityksen kanssa",
      "alates": "alkaen",
      "Broneeri →": "Varaa →",

      /* HOMEPAGE — REVIEWS */
      "Google Arvustused": "Google-arvostelut",
      "Mida kliendid": "Mitä asiakkaat",
      "räägivad": "sanovat",
      "Ühendamine Google'iga...": "Yhdistetään Googleen...",
      "Uuenda": "Päivitä",

      /* HOMEPAGE — BOOKING WIDGET */
      "Online Broneerimine": "Verkkovaraus",
      "Broneeri oma": "Varaa oma",
      "aeg kohe": "aika nyt",
      "1 / 3 — Vali Teenus": "1 / 3 — Valitse Palvelu",
      "2 / 3 — Vali Kuupäev": "2 / 3 — Valitse Päivä",
      "3 / 3 — Vali Kellaaeg": "3 / 3 — Valitse Aika",
      "Vali teenus...": "Valitse palvelu...",
      "Vali Kuupäev →": "Valitse Päivä →",
      "Kinnita Broneering →": "Vahvista Varaus →",
      "← Tagasi": "← Takaisin",
      "Broneering Kinnitatud!": "Varaus Vahvistettu!",
      "Uus Broneering": "Uusi Varaus",
      "Kinnitus saadetakse e-mailile.": "Vahvistus lähetetään sähköpostiisi.",
      "Broneeri kohe": "Varaa nyt",
      "Vali teenus & ava kalender": "Valitse palvelu & avaa kalenteri",

      /* HOMEPAGE — BLOG SLIDE */
      "◆  Ilumeistri Blogi": "◆  Ilumeisterin Blogi",
      "Ekspertteadmised": "Asiantuntijatietoa",
      "& Uudised": "& Uutiset",
      "Laura ekspertnõuanded, tootearvustused ja kaunitsuudised.": "Lauran asiantuntijavinkit, tuotearvostelut ja kaunesuutiset.",
      "Vaata kõiki artikleid": "Katso kaikki artikkelit",

      /* HOMEPAGE — MAP */
      "Meie Asukoht": "Sijaintimme",
      "Aadress": "Osoite",
      "Tööaeg": "Aukioloajat",
      "Telefon": "Puhelin",
      "Ava Google Maps": "Avaa Google Maps",

      /* TEENUSED PAGE */
      "Ripsmepikendused & Kaunitushooldused": "Ripsienpidennykset & Kauneushoidot",
      "Hinnakirja Ülevaade": "Hinnaston Katsaus",
      "Teenus": "Palvelu",
      "Kestus": "Kesto",
      "Hooldus": "Huolto",
      "Hind": "Hinta",
      "Valmis alustama?": "Valmiina aloittamaan?",
      "täna": "tänään",
      "Küsi Nõu": "Kysy Neuvoa",

      /* BRONEERI PAGE */
      "Võtke Meiega Ühendust": "Ota Yhteyttä",
      "Online Broneerimine": "Verkkovaraus",
      "oma aeg": "sinun aika",
      "Vali sobiv": "Valitse sopiva",
      "aeg": "aika",
      "Teisipäev – Laupäev": "Tiistai – Lauantai",
      "Teisipäev – Laupäev: 12:00–21:00": "Tiistai – Lauantai: 12:00–21:00",
      "Pühapäev – Esmaspäev: Suletud": "Sunnuntai – Maanantai: Suljettu",
      "Laupäev": "Lauantai",
      "Pühapäev – Esmaspäev": "Sunnuntai – Maanantai",
      "Suletud": "Suljettu",
      "Oluline Teada": "Tärkeää Tietoa",
      "Tühistamise Poliitika": "Peruutuskäytäntö",
      "Makseviisid": "Maksutavat",
      "Protseduuriks Valmistumine": "Valmistautuminen",
      "Korduvad Küsimused": "Usein Kysytyt Kysymykset",
      "KKK": "UKK",
      "Kui kaua protseduur kestab?": "Kuinka kauan toimenpide kestää?",
      "Mida peaksin enne protseduuri teadma?": "Mitä minun pitäisi tietää ennen toimenpidettä?",
      "Kui kaua ripsmepikendused kestavad?": "Kuinka kauan ripsienpidennykset kestävät?",
      "Kas tundlikud silmad sobivad?": "Sopivatko herkät silmät?",
      "Kuidas tühistada või aega muuta?": "Kuinka peruuttaa tai muuttaa aikaa?",

      /* KONTAKT PAGE */
      "& Asukoht": "& Sijainti",
      "Meie Kontaktandmed": "Yhteystietomme",
      "Leia meid": "Löydä meidät",
      "Vanalinnas": "vanhasta kaupungista",
      "E-post": "Sähköposti",
      "Ava Google Maps →": "Avaa Google Maps →",
      "Teekonnakirjeldus": "Reittiohjeet",
      "Teisipäev": "Tiistai",
      "Kolmapäev": "Keskiviikko",
      "Neljapäev": "Torstai",
      "Reede": "Perjantai",
      "Saada Sõnum": "Lähetä Viesti",
      "Eesnimi": "Etunimi",
      "Perekonnanimi": "Sukunimi",
      "Teema": "Aihe",
      "Sõnum": "Viesti",
      "Vali teema...": "Valitse aihe...",
      "Broneerimine": "Varaus",
      "Teenuse info": "Palvelutieto",
      "Hinnakiri": "Hinnasto",
      "Koolitused": "Koulutukset",
      "Muu küsimus": "Muu kysymys",
      "Saada Sõnum →": "Lähetä Viesti →",
      "Sõnum saadetud!": "Viesti lähetetty!",

      /* BLOG LISTING */
      "Ekspertteadmised & Uudised": "Asiantuntijatieto & Uutiset",
      "Ilumeistri": "Ilumeisterin",
      "NAUTIMINE": "ESITELTY",
      "Tootearvustus": "Tuotearvostelu",
      "Uudised": "Uutiset",
      "Ekspertteadmised": "Asiantuntijatieto",
      "Hooldus & Nõuanded": "Hoito & Vinkit",
      "Loe edasi →": "Lue lisää →",
      "Loe edasi": "Lue lisää",
      "Püsi Kursis": "Pysy Ajan Tasalla",
      "uudiskiri": "uutiskirje",
      "Liitu →": "Tilaa →",
      "Täname! ✦": "Kiitos! ✦",

      /* ARTICLE PAGE */
      "Loe Veel": "Lue Lisää",
      "Seotud": "Liittyvät",
      "artiklid": "artikkelit",
      "← Tagasi blogi": "← Blogi",
      "Autor": "Kirjoittaja",

      /* PRODUCTS PAGE */
      "Puhtad ripsmed,": "Puhtaat ripset,",
      "iga päev.": "joka päivä.",
      "Lisa korvi": "Lisää koriin",
      "Osta kohe": "Osta heti",
      "Kollektsioon": "Kokoelma",

      /* PRODUCTS GRID SECTION (homepage) */
      "◆  Meie Kauplus": "◆  Kauppamme",
      "Meie Enimmüüdud": "Myydyimmät",
      "Professionaalsed tooted, mida Laura ise kasutab ja soovitab.": "Ammattimaiset tuotteet, joita Laura itse käyttää ja suosittelee.",
      "Vaata kõiki tooteid": "Katso kaikki tuotteet",

      /* HEADER — ACCOUNT / CART */
      "Logi sisse": "Kirjaudu sisään",
      "Minu konto": "Oma tili",
      "Ostukorv": "Ostoskori",
      "Ostukorv on tühi": "Ostoskorisi on tyhjä",
      "Vaata tooteid →": "Katso tuotteita →",
      "Kokku": "Yhteensä",
      "Jätka kassasse": "Siirry kassalle",
      "Vaata ostukorvi": "Katso ostoskori",
      "Eemalda": "Poista",
      "Valitud teenus:": "Valittu palvelu:",
      "Otsas": "Loppunut",

      /* GALLERY / ABOUT / REVIEWS / HERO — EXTRAS */
      "Meie Tööd": "Töitämme",
      "Valik tegelikest töödest": "Valikoima todellisista töistä",
      "Klientide Arvustused": "Asiakasarvostelut",
      "Vaata Google'is": "Katso Googlessa",
      "Värskenda": "Päivitä",
      "Sinu kunstnik": "Sinun taiteilijasi",
      "Sinu Kunstnik": "Sinun taiteilijasi",
      "Ripsmekunstnik": "Ripsiartisti",
      "Ripsmemeister · 15+ aasta rahvusvaheline kogemus": "Ripsimestaari · 15+ vuoden kansainvälinen kokemus",
      "AASTAT KOGEMUST": "VUOTTA KOKEMUSTA",
      "5.0/5 Google hinnang · 2000+ rahulolevat klienti": "5.0/5 Google-arvio · 2000+ tyytyväistä asiakasta",
      "Laadimine…": "Ladataan…",
      "Laadib arvustusi…": "Ladataan arvosteluja…",
      "Live Google andmed": "Live Google-tiedot",
      "Vahemälust": "Välimuistista",
      "Vahemälust (kuni 1h vana)": "Välimuistista (enintään 1h vanha)",      "(100% 5-tärni)": "(100% 5 tähteä)",
      "Aktsepteerime kontaktivabat kaarti, sularaha ja pangaülekannet. Makse toimub peale protseduuri sooritamist salongis.": "Hyväksymme lähimaksukortin, käteisen ja pankkisiirron. Maksu suoritetaan toimenpiteen jälkeen salongissa.",
      "Asian Lash Lift koos toonimisega — €45": "Asian Lash Lift sävytyksellä — 45 €",
      "Broneeri mugavalt veebis — vali teenus, kuupäev ja kellaaeg. Kinnitus saadetakse Teie e-mailile kohe pärast broneerimist.": "Varaa kätevästi verkossa — valitse palvelu, päivä ja kellonaika. Vahvistus lähetetään sähköpostiisi heti varauksen jälkeen.",
      "Broneerimise": "Varaaminen",
      "Enne": "Ennen",
      "Enne & Pärast": "Ennen & Jälkeen",
      "Esitoode": "Esittelytuote",
      "Hammas Kivi": "Hammaskoru",
      "Hammas Kivi — Hind kokkuleppel": "Hammaskoru — Hinta sopimuksen mukaan",
      "Hammas Kivi · Uus 2026": "Hammaskoru · Uusi 2026",
      "Hind kokkuleppel": "Hinta sopimuksen mukaan",
      "hinnad": "hinnat",
      "Hübriid LED Ripsmepikendused": "Hybridi LED-ripsienpidennykset",
      "Hübriid LED Ripsmepikendused — €65": "Hybridi LED-ripsienpidennykset — 65 €",
      "Ilumeister Eksklusiiv": "Ilumeister Eksklusiivi",
      "Ilumeister salong asub Tallinna südames — rahulikul, eksklusiivselt Teile mõeldud ruumis Rüütli tänaval. Olete alati oodatud!": "Ilumeister-salonki sijaitsee Tallinnan sydämessä — rauhallisessa, yksinomaan sinulle suunnitellussa tilassa Rüütli-kadulla. Olet aina tervetullut!",
      "Ilumeister Studio": "Ilumeister Studio",
      "ise": "itse",
      "Keri alla": "Vieritä alas",
      "Klassikalised LED Ripsmepikendused": "Klassiset LED-ripsienpidennykset",
      "Klassikalised LED Ripsmepikendused — €60": "Klassiset LED-ripsienpidennykset — 60 €",
      "Kõik": "Kaikki",
      "Kõik hinnad sisaldavad käibemaksu.": "Kaikki hinnat sisältävät arvonlisäveron.",
      "Korrektuur": "Korjaus",
      "Kulmud": "Kulmat",
      "Kulmude Disain": "Kulmien muotoilu",
      "Kulmude Disain — €20–40": "Kulmien muotoilu — 20–40 €",
      "Küsimused, tagasiside või muud soovid — vastame esimesel võimalusel.": "Kysymykset, palaute tai muut toiveet — vastaamme mahdollisimman pian.",
      "Küüned · Uus 2026": "Kynnet · Uusi 2026",
      "Küünekujundus": "Kynsien muotoilu",
      "Küünekujundus — Hind kokkuleppel": "Kynsien muotoilu — Hinta sopimuksen mukaan",
      "Lash & Brow Studio · Kollektsioon": "Lash & Brow Studio · Kokoelma",
      "Laura on valmis looma Teile täiusliku ilutulemi. Broneerige mugavalt veebis — valige teenus, kuupäev ja kellaaeg.": "Laura on valmis luomaan sinulle täydellisen kauneustuloksen. Varaa kätevästi verkossa — valitse palvelu, päivä ja kellonaika.",
      "LED Ripsmepikendused": "LED-ripsienpidennykset",
      "Makseviisid:": "Maksutavat:",
      "Näe vahet": "Näe ero",
      "Palun tühistage broneering vähemalt 24 tundi ette. Hilisem tühistamine toob kaasa 100% teenustasu. Haigestumise korral võtke ühendust esimesel võimalusel.": "Peru varaus vähintään 24 tuntia etukäteen. Myöhäisestä peruutuksesta veloitetaan 100 % palvelumaksusta. Sairastapauksessa ota yhteyttä mahdollisimman pian.",
      "Palun tulge puhaste silmadega — ilma ripsmetušši ja silmaümbruskreemita. Kontaktläätsi kasutajatel soovitame läätsi mitte kanda protseduuril.": "Tule puhtailla silmillä — ilman ripsiväriä ja silmänympärysvoidetta. Piilolinssien käyttäjille suosittelemme, ettei linssejä käytetä toimenpiteen aikana.",
      "Pärast": "Jälkeen",
      "Pruunid LED Ripsmepikendused": "Ruskeat LED-ripsienpidennykset",
      "Pruunid LED Ripsmepikendused — al. €60 (–15%)": "Ruskeat LED-ripsienpidennykset — alk. 60 € (–15 %)",
      "räägivad ise": "puhuvat puolestaan",
      "Ripsme": "Ripsi",
      "Ripsmete Korrektuur": "Ripsien korjaus",
      "Ripsmete Korrektuur — €15–60": "Ripsien korjaus — 15–60 €",
      "rituaal,": "rituaali,",
      "Saa esimesena teada uutest teenustest, erihinnapakkumistest ja Laura ekspertnõuannetest. Liitu meie eksklusiivsete lugejatega.": "Ole ensimmäisten joukossa kuulemassa uusista palveluista, erikoistarjouksista ja Lauran asiantuntijavinkeistä. Liity eksklusiivisten lukijoidemme joukkoon.",
      "Šampoon": "Shampoo",
      "stuudio südames": "studion sydämessä",
      "Täielik": "Täydellinen",
      "Tallinna Vanalinnas,": "Tallinnan vanhassakaupungissa,",
      "Täname teiega ühenduse võtmise eest. Vastame Teile esimesel võimalusel, hiljemalt 1 tööpäeva jooksul.": "Kiitos yhteydenotostasi. Vastaamme sinulle mahdollisimman pian, viimeistään 1 työpäivän kuluessa.",
      "Teie e-posti aadress": "Sähköpostiosoitteesi",
      "tingimused": "ehdot",
      "Töid, mis": "Töitä, jotka",
      "Tühistamine:": "Peruutus:",
      "Üheksa eksklusiivset teenust — hoolikalt valitud, professionaalselt sooritatud. Iga teenus on kohandatud Sinu unikaalsele ilule.": "Yhdeksän eksklusiivista palvelua — huolellisesti valittu, ammattimaisesti toteutettu. Jokainen palvelu on räätälöity sinun ainutlaatuiselle kauneudellesi.",
      "vaata lähemalt.": "katso tarkemmin.",
      "Vastavalt vajadusele": "Tarpeen mukaan",
      "Volüümi LED Ripsmepikendused": "Volyymi LED-ripsienpidennykset",
      "Volüümi LED Ripsmepikendused — €70": "Volyymi LED-ripsienpidennykset — 70 €"
    }
  };

  /* ── ENGINE ────────────────────────────────────────────────────────────── */

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, IFRAME: 1, SVG: 1 };
  var currentLang = null;
  var _mutPending = null;

  function translateNode(node, map) {
    if (node.nodeType === 3) {
      var raw = node.textContent;
      var trimmed = raw.trim();
      if (trimmed && map[trimmed] !== undefined) {
        node.textContent = raw.replace(trimmed, map[trimmed]);
      }
    } else if (node.nodeType === 1) {
      if (SKIP_TAGS[node.tagName]) return;
      if (node.hasAttribute('placeholder')) {
        var ph = node.getAttribute('placeholder').trim();
        if (map[ph]) node.setAttribute('placeholder', map[ph]);
      }
      if (node.hasAttribute('aria-label')) {
        var al = node.getAttribute('aria-label').trim();
        if (map[al]) node.setAttribute('aria-label', map[al]);
      }
      for (var i = 0; i < node.childNodes.length; i++) {
        translateNode(node.childNodes[i], map);
      }
    }
  }

  function applyLang(lang) {
    if (lang === 'et') {
      try { localStorage.removeItem('ilm_lang'); } catch (e) {}
      location.reload();
      return;
    }
    var map = M[lang];
    if (!map) return;
    /* The walker translates FROM Estonian source text. If the page is already
       showing a DIFFERENT non-ET language, the DOM no longer matches the ET keys,
       so a live re-walk would do nothing. Reload to the ET base first, store the
       target, and init() applies it cleanly on load. Makes EN↔FI switching work. */
    if (currentLang && currentLang !== lang) {
      try { localStorage.setItem('ilm_lang', lang); } catch (e) {}
      location.reload();
      return;
    }
    currentLang = lang;
    translateNode(document.body, map);
    if(typeof window._ilmFooterI18n === 'function') window._ilmFooterI18n(lang);
    updateButtons(lang);
    try { localStorage.setItem('ilm_lang', lang); } catch (e) {}
    startObserver();
  }

  function updateButtons(lang) {
    document.querySelectorAll('.lang-btn[data-lang]').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-lang') === lang);
    });
    /* sync mobile dropdown trigger + options */
    if (typeof mhlSyncActive === 'function') mhlSyncActive(lang);
  }

  function retranslate() {
    if (currentLang && M[currentLang]) {
      translateNode(document.body, M[currentLang]);
    }
  }

  /* Watches for JS-rendered content (review cards, booking widget updates, etc.)
     and translates newly added nodes automatically. Debounced to 80ms to avoid
     performance issues during rapid DOM mutations. */
  var _observer = null;
  function startObserver() {
    if (_observer) return;
    _observer = new MutationObserver(function (mutations) {
      if (_mutPending) clearTimeout(_mutPending);
      _mutPending = setTimeout(function () {
        var map = currentLang && M[currentLang];
        if (!map) return;
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (added[j].nodeType === 1 || added[j].nodeType === 3) {
              translateNode(added[j], map);
            }
          }
        }
        _mutPending = null;
      }, 80);
    });
    _observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ── INIT ─────────────────────────────────────────────────────────────── */
  function init() {
    try {
      var stored = localStorage.getItem('ilm_lang');
      if (stored && M[stored]) {
        currentLang = stored;
        translateNode(document.body, M[stored]);
        if(typeof window._ilmFooterI18n === 'function') window._ilmFooterI18n(stored);
        updateButtons(stored);
        startObserver();
      } else {
        updateButtons('et');
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── PUBLIC API ───────────────────────────────────────────────────────── */
  window.setLang = applyLang;
  window.ILM = { retranslate: retranslate, startObserver: startObserver };

})();
